import { Col, Modal, Row } from "antd";
import "../../../../assets/style/modalStyle/postNews.scss";
import TranslateText from "../../TranslateText";
import { useEffect, useState } from "react";
import { IconPUGroupNotify } from "../../../../assets/icon";
const ModalPreviewPostGroupNotify = ({ open, setOpen, data }) => {
  const handCancel = () => {
    setOpen(false);
  };
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  useEffect(() => {
    if (data.firstImage instanceof File) {
      const url = URL.createObjectURL(data.firstImage);
      setPreviewImageUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [data.firstImage]);

  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text="Xem trước thông báo" />}
        centered
        width={931}
        open={open}
        onCancel={handCancel}
        footer={[]}
        style={{
          minHeight: "50%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {data.title ? (
            <div className="group-notify">
              <button className="close-btn">
                <IconPUGroupNotify />
              </button>
              <h3 className="title">{data.title}</h3>
              {/* <div
          className="content"
          dangerouslySetInnerHTML={{
            __html: data?.data.content.replace(
              /img src="\/api\/image/g,
              'img src="' + window.SERVER_URL + "/api/image"
            ),
          }}
        ></div> */}
              {data.typePost === 0 ? (
                // <p className="content">{data.content}</p>
                   <div
                  className="contentDetail"
                  dangerouslySetInnerHTML={{
                    __html: data.content.replace(
                      new RegExp(window.SERVER_CLIENT_URL, "g"),
                      window.SERVER_URL
                    ),
                  }}
                ></div>
              ) : (
                <>
                  {previewImageUrl && (
                    <img
                      onClick={() => {
                        if (data.redirectUrl) {
                          window.open(data.redirectUrl, "_blank");
                        }
                      }}
                      src={previewImageUrl}
                      alt="img"
                      style={{ width: 440, cursor: "pointer" }}
                    />
                  )}
                </>
              )}
            </div>
          ) : null}
        </div>
      </Modal>
    </>
  );
};

export default ModalPreviewPostGroupNotify;
